import React, { useEffect } from 'react';

/**
 * Keeps the browser window from scrolling while it is mounted. For full-screen surfaces such
 * as the workspace, where every panel scrolls on its own: an element that reaches past the
 * window can then neither add a window scrollbar nor shift the page. No room is kept for a
 * window scrollbar either (pages that scroll keep it): the surface reaches the window's edge.
 */
export const PageScrollLock: React.FC = () => {
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const previous = { html: html.style.overflow, body: body.style.overflow, gutter: html.style.scrollbarGutter };
    html.style.overflow = 'hidden';
    html.style.scrollbarGutter = 'auto';
    body.style.overflow = 'hidden';
    // Hidden overflow can still be scrolled from code (focusing a field, scrollIntoView): put it back
    const reset = () => {
      if (html.scrollTop || html.scrollLeft) html.scrollTo(0, 0);
      if (body.scrollTop || body.scrollLeft) body.scrollTo(0, 0);
    };
    reset();
    window.addEventListener('scroll', reset, { passive: true });
    body.addEventListener('scroll', reset, { passive: true });
    return () => {
      window.removeEventListener('scroll', reset);
      body.removeEventListener('scroll', reset);
      html.style.overflow = previous.html;
      html.style.scrollbarGutter = previous.gutter;
      body.style.overflow = previous.body;
    };
  }, []);
  return null;
};

export default PageScrollLock;
